module.exports = __webpack_public_path__ + "img/1GDr2ftl6yjbKHt_PyZsVi8aLF0aatCK1.449c5d6c.png";